import { FormField, InputSlider, InputAdornment, UIText2 } from '@cian/ui-kit';
import { plural } from '@cian/utils';
import * as React from 'react';
import * as styles from './MortgageFields.css';

interface IMortgageFieldsProps {
  maxPrice: number;
  minPrice: number;
  price: number;
  initialPayment: number;
  initialPaymentPercent: number;
  paymentPeriod: number;

  onPriceChange(price: number): void;
  onPaymentPeriodChange(paymentPeriod: number): void;
  onInitialPaymentChange(initialPayment: number): void;
}

export const MortgageFields: React.FC<IMortgageFieldsProps> = ({
  onPriceChange,
  onPaymentPeriodChange,
  onInitialPaymentChange,
  maxPrice,
  minPrice,
  price,
  initialPayment,
  initialPaymentPercent,
  paymentPeriod,
}) => {
  return (
    <div className={styles['fields']}>
      <div className={styles['field']}>
        <FormField label="Стоимость строительства" withoutMargin>
          <InputSlider
            value={price}
            onChange={onPriceChange}
            rightAdornment={<InputAdornment>₽</InputAdornment>}
            min={minPrice}
            max={maxPrice}
            step={100000}
          />
        </FormField>
      </div>
      <div className={styles['field']}>
        <div className={styles['percent']}>
          <UIText2 as="span" color="text-secondary-default">
            {initialPaymentPercent}%
          </UIText2>
        </div>
        <FormField label="Первоначальный взнос" withoutMargin>
          <InputSlider
            value={initialPayment}
            onChange={onInitialPaymentChange}
            rightAdornment={<InputAdornment>₽</InputAdornment>}
            min={0}
            max={price}
            step={100000}
          />
        </FormField>
      </div>
      <div className={styles['field']}>
        <FormField label="Срок" withoutMargin>
          <InputSlider
            value={paymentPeriod}
            onChange={onPaymentPeriodChange}
            rightAdornment={<InputAdornment>{plural(paymentPeriod, ['год', 'года', 'лет'])}</InputAdornment>}
            min={1}
            max={30}
            step={1}
          />
        </FormField>
      </div>
    </div>
  );
};
